$(document).ready(function()
{

    /**
     *
     * @param $scroll_navigation {jQuery}
     */
    let scroll_navigation = ($scroll_navigation) =>{
        let page_positions = {};
        let page_id_order = [];

        let saved_scroll_top = null;
        let locked_scroll_position = null;

        let override_anchors = () => {
            $("a").click((event) => {
                let $anchor = $(event.target).closest("a");
                let href = $anchor.attr("href");
                let page_id = href.length > 1 && href.charAt(0) === "#" ? href.slice(1) : "";
                if(page_id){
                    event.preventDefault();
                    hide_menu();
                    show_page(page_id, true);
                }
            })
        }

        let show_menu = () =>{
            saved_scroll_top = $(window).scrollTop();
            $("html").addClass('nav-is-open');
        }

        let hide_menu = () =>{
            $("html").removeClass('nav-is-open');
            if(saved_scroll_top !== null){
                window.scrollTo({ top:saved_scroll_top, behavior: "instant"})
                handle_current_scroll_position();
                saved_scroll_top = null;
            }
        }

        let enable_menu = () => {

            $( ".menu-button" ).click( (event) =>
            {

                event.preventDefault();

                if ($("html").hasClass('nav-is-open'))
                {
                    hide_menu();
                }
                else
                {
                    show_menu();
                }

            });
        }

        /**
         *
         * @param page_index {int}
         * @returns {int}
         */
        let get_page_size = (page_index) =>{
            let $pages = $scroll_navigation.find(".page");
            if(page_index >= $pages.length){
                return 0;
            }
            let $page = $($pages[page_index]);
            let is_horizontal = $page.hasClass("is-horizontal");
            let page_size;
            if(!is_horizontal){
                page_size = $page.outerHeight();
            } else {
                page_size = $page.outerWidth();
            }
            if(page_index === $pages.length - 1){
                return page_size;
            }
            let $next_page = $($pages[page_index + 1]);
            let next_is_horizontal = $next_page.hasClass("is-horizontal");
            if(next_is_horizontal === is_horizontal){
                return page_size;
            }
            let $page_position = $scroll_navigation.find(".page-position");
            let height_width_diff = $page_position.width() - $page_position.height();

            if(!is_horizontal){
                if(height_width_diff > 0){
                    page_size += height_width_diff;
                }
            } else {
                if(height_width_diff < 0){
                    page_size += height_width_diff * -1;
                }
            }
            return page_size;
        }

        let update_vertical_scroll = () => {

            page_positions = {
                home: 0
            };
            page_id_order = ['home'];
            let scroll_size = 0;
            let $pages = $scroll_navigation.find(".page");
            $pages.each((index, element) => {
                let $page = $(element);
                let id = $page.attr("id");
                if(index !== 0 && id && !page_positions[id]){
                    page_positions[id] = scroll_size;
                    page_id_order.push(id);
                }
                scroll_size += get_page_size(index);
            });
            scroll_size += $scroll_navigation.find("#black-bar-space").outerHeight();
            let $vertical_scroll = $scroll_navigation.find(".vertical-scroll");
            $vertical_scroll.height(scroll_size);
            handle_current_scroll_position();
        }

        /**
         *
         * @param check_for_hash {boolean=}
         */
        let handle_current_scroll_position = (check_for_hash) => {
            if(locked_scroll_position !== null){
                window.scrollTo({ top:locked_scroll_position, behavior: "instant"});
            }
            let $pages = $scroll_navigation.find(".page");
            let $page_position = $scroll_navigation.find(".page-position");
            let left_offset = $page_position.position().left;
            let top_offset = $page_position.position().top;
            let position = 0;
            $pages.each((index, element) => {
                let $page = $(element);
                let is_horizontal = $page.hasClass("is-horizontal");
                if(!is_horizontal){
                    $page.css("top", (top_offset + position - $(window).scrollTop()) + "px");
                } else {
                    $page.css("left", (left_offset + position - $(window).scrollTop()) + "px");
                }
                position += get_page_size(index);
            });

            if(check_for_hash){
                let previous_page_id = get_current_page_id();
                let scroll_top = $(window).scrollTop();
                let new_page_id = "home";
                for(let i = 1; i < page_id_order.length; i ++){
                    let page_id = page_id_order[i];
                    if(page_positions[page_id] > scroll_top){
                        break;
                    }
                    new_page_id = page_id;
                }
                if(new_page_id !== previous_page_id){
                    history.pushState({}, '', new_page_id !== "home" ? "#"+new_page_id : " ");
                }
            }
            update_body_page_id();
        }

        /**
         *
         * @param page_id {string}
         * @param animate {boolean=}
         */
        let show_page = (page_id, animate) => {
            let target = page_id && page_positions.hasOwnProperty(page_id) ? page_positions[page_id] : null;
            if(target !== null){
                if(!animate){
                    locked_scroll_position = target;
                    setTimeout(() => {
                        locked_scroll_position = null;
                    }, 500);
                    window.scrollTo({ top:target, behavior: "instant"})
                    handle_current_scroll_position();
                } else {
                    let distance = Math.abs($(window).scrollTop() - target);
                    $('html,body').animate({scrollTop: target}, Math.round(distance / 30));
                }
            }
        }

        let update_body_page_id = () => {
            let page_id= get_current_page_id();
            let $body = $("body");
            if(page_id !== $body.attr("page-id")){
                $body.attr("data-page-id", page_id);
            }
        }

        /**
         *
         * @returns {string}
         */
        let get_current_page_id = () => {
            let hash = window.location.hash;
            let page_id = hash.length > 1 && hash.charAt(0) === "#" ? hash.slice(1) : "";
            return page_id ? page_id : "home";
        }
        override_anchors();
        enable_menu();

        setTimeout(()  =>{
            $("body").addClass("initialized")
            update_vertical_scroll();
            show_page(get_current_page_id());
            $(window).on("resize", () => update_vertical_scroll());
            $(window).scroll(() => handle_current_scroll_position(true));

        }, 100);



    }
    let $scroll_navigation = $("#scroll-navigation");
    if($scroll_navigation.length){
        scroll_navigation($scroll_navigation);
    }
});